import * as React from 'react';

import { EFieldGroupName } from '../../../../types/field';
import { CommonGroupRowContainer } from './common';

export interface ITableGroupRowContainerProps {
  name: EFieldGroupName;
  title?: string | null;
}

export const TableGroupRowContainer = ({ name, title }: ITableGroupRowContainerProps) => {
  if (!title) {
    return null;
  }

  switch (name) {
    default:
      return <CommonGroupRowContainer>{title}</CommonGroupRowContainer>;
  }
};
